// 备案信息配置示例
// 使用方法：复制本文件为 config.js，然后修改里面的值
// 注意：config.js 已加入 .gitignore，不会被提交到仓库

// 是否显示备案信息
export const icpVisible = true;
// 备案号（例如：陕ICP备16000646号）
export const icpNumber = '陕ICP备16000646号';
// 备案系统链接（工信部备案常用：https://beian.miit.gov.cn/）
export const icpLink = 'https://beian.miit.gov.cn/';

// 你也可以在这里继续扩展更多配置，例如公安备案：
// export const gonganNumber = '';
// export const gonganLink = 'https://beian.mps.gov.cn/#/query/webSearch';
